import {
  forwardRef,
  memo,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import api from "../../../../Component/axios_Interceptor/api";
import { Order_count } from "../../../../Component/Interface/Order";
import url from "../../../../Component/server";
import { fontStyles } from "../../../../Component/style/common_font";
import { RowView2 } from "../../../../Component/style/common_style";

const pages = [
  { name: "미입금", key: "non-pay" },
  { name: "입금확인", key: "done-pay" },
  { name: "배송준비", key: "ready-deli" },
  { name: "배송완료", key: "done-deli" },
  { name: "주문취소", key: "cancle" },
  { name: "환불처리", key: "refound" },
  { name: "전체", key: "all" },
];

const Order_select_menu = forwardRef(
  ({ go_page }: { go_page: (key: string) => void }, ref) => {
    const { page = "" } = useParams();

    useImperativeHandle(ref, () => ({ get_order_count }));

    const [status_미입금, setStatus_미입금] = useState(0);
    const [status_입금확인, setStatus_입금확인] = useState(0);
    const [status_배송준비, setStatus_배송준비] = useState(0);
    const [status_배송완료, setStatus_배송완료] = useState(0);
    const [status_주문취소, setStatus_주문취소] = useState(0);
    const [status_환불처리, setStatus_환불처리] = useState(0);
    const [status_전체, setStatus_전체] = useState(0);
    const [status_미입금_user, setStatus_미입금_user] = useState(0);
    const [status_입금확인_user, setStatus_입금확인_user] = useState(0);
    const [status_배송준비_user, setStatus_배송준비_user] = useState(0);
    const [status_배송완료_user, setStatus_배송완료_user] = useState(0);
    const [status_주문취소_user, setStatus_주문취소_user] = useState(0);
    const [status_환불처리_user, setStatus_환불처리_user] = useState(0);
    const [status_전체_user, setStatus_전체_user] = useState(0);
    const get_order_count = async () => {
      try {
        const res = await api.get(url.Communication_url.order_count);
        const data = res.data || [];
        data.forEach(
          (item: { user_count: string; cnt: string; order_status: string }) => {
            const user_cnt = Number(item.user_count);
            const cnt = Number(item.cnt);
            switch (item.order_status) {
              case "미입금":
                setStatus_미입금(cnt);
                setStatus_미입금_user(user_cnt);
                break;
              case "입금확인":
                setStatus_입금확인(cnt);
                setStatus_입금확인_user(user_cnt);
                break;
              case "배송준비":
                setStatus_배송준비(cnt);
                setStatus_배송준비_user(user_cnt);
                break;
              case "배송완료":
                setStatus_배송완료(cnt);
                setStatus_배송완료_user(user_cnt);
                break;
              case "주문취소":
                setStatus_주문취소(cnt);
                setStatus_주문취소_user(user_cnt);
                break;
              case "환불처리":
                setStatus_환불처리(cnt);
                setStatus_환불처리_user(user_cnt);
                break;
              case "전체":
                setStatus_전체(cnt);
                setStatus_전체_user(user_cnt);
                break;
              default:
                break;
            }
          }
        );
      } catch (error) {
        console.error("데이터 로드 실패:", error);
      }
    };
    useEffect(() => {
      get_order_count();
    }, [page]);
    const searchCnt = (name: string) => {
      switch (name) {
        case "미입금":
        case "non-pay":
          return status_미입금;
        case "입금확인":
        case "done-pay":
          return status_입금확인;
        case "배송준비":
        case "ready-deli":
          return status_배송준비;
        case "배송완료":
        case "done-deli":
          return status_배송완료;
        case "주문취소":
          return status_주문취소;
        case "환불처리":
          return status_환불처리;
        case "전체":
          return status_전체;
        case "미입금_유저":
          return status_미입금_user;
        case "입금확인_유저":
          return status_입금확인_user;
        case "배송준비_유저":
          return status_배송준비_user;
        case "배송완료_유저":
          return status_배송완료_user;
        case "주문취소_유저":
          return status_주문취소_user;
        case "환불처리_유저":
          return status_환불처리_user;
        case "전체_유저":
          return status_전체_user;
        default:
          return 0;
      }
    };

    return (
      <PageNameArea>
        {pages.map(({ name, key }) => (
          <div
            key={key}
            className={page === key ? "this" : ""}
            onClick={() => {
              if (page !== key) {
                go_page(key);
              }
            }}
          >
            {name}
            {searchCnt(`${name}_유저`)}명({searchCnt(name)}건)
          </div>
        ))}
      </PageNameArea>
    );
  }
);

export default memo(Order_select_menu);

const PageNameArea = styled(RowView2)`
  margin-bottom: 1rem;
  flex-wrap: wrap;
  div {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 11rem;
    height: 3.2rem;
    box-sizing: border-box;
    padding: 0.5rem 0.8rem;
    margin-top: 0.5rem;
    margin-right: 1rem;
    ${fontStyles.medium}
    font-size: 20px;
    color: #8e8e8e;
    border-radius: 8px;
    cursor: pointer;
  }
  div.this {
    color: white;
    background-color: #2d2d2d;
  }
`;
